/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowTriviaNightExtendedTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowTriviaNightExtended,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Let’s Test Our Knowledge!",
    "Extended Trivia Night Awaits!",
    "Challenge Your Brain!",
  ],
  title: "Extended Trivia Night",
  description: "Organize a fun extended trivia night.",
  longDescription:
    "Gather your friends for an exciting trivia night with extended rounds! Choose a date, decide on categories, and plan snacks for the evening!",
  emoji: "🧠",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Party,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Extended Trivia Night",
          emoji: "🧠",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we have the trivia night?",
          emoji: "📅",
          completeAction: {
            question: "Decide on trivia categories?",
            description:
              "What categories should we include in the trivia night?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What trivia categories should we choose?",
                emoji: "📚",
                completeAction: {
                  question: "Decide on teams?",
                  description:
                    "How should we organize teams for the trivia night?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What teams should we form?",
                      emoji: "👥",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Let the Trivia Begin!",
    outroDescription: "Your trivia night plans are set! Enjoy the fun!",
  },
};
